import { cn, IconButton, XIcon } from "@au-schein-de/au-ui-library";

type CartHeaderProps = {
	title?: string;
	onCloseButtonClick?: () => void;
};

/** Figma 483 — close on green header (node 85:6333). */
const mobileCloseButtonClassName =
	"!size-10 !min-h-10 !min-w-10 !rounded-full !bg-ansay-400 hover:!bg-[#358f81] !text-white [&_svg]:!text-white md:!bg-white md:hover:!bg-gray-200 md:!text-gray-500 md:[&_svg]:!text-gray-500";

export function CartHeader({ title, onCloseButtonClick }: CartHeaderProps) {
	return (
		<div
			className={cn(
				"flex h-16 items-center border-b border-brand-600 bg-ansay-900 px-4 backdrop-blur-[12px] md:h-auto md:border-b-0 md:bg-transparent md:p-0 md:backdrop-blur-none",
				title ? "justify-between" : "justify-end",
			)}
		>
			{title ? (
				<h2 className="text-h5 text-white md:text-h4 md:text-gray-700">
					{title}
				</h2>
			) : null}
			<IconButton
				onClick={onCloseButtonClick}
				icon={<XIcon.Raw />}
				shape="circle"
				iconSize={5}
				aria-label="Close cart"
				className={mobileCloseButtonClassName}
				data-testid="close-cart-button"
			/>
		</div>
	);
}
